import TrainerFilter from './TrainerFilter.jsx';

export default TrainerFilter;
